'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  background-color: #ffffff;\n  border-bottom: solid 1px ', ';\n  border-left: solid 1px ', ';\n  border-right: solid 1px ', ';\n  border-radius: 0 0 2px 2px; // top-left, top-right, bottom-right, bottom-left\n  border-top: none;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n  color: ', ';\n  font-family: ', ';\n  font-size: ', ';\n  max-height: 260px;\n  outline: none;\n  right: 0px;\n  top: 0px;\n  z-index: 1000;\n\n  width: ', ';\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n\n  div[name=\'listPanelGroupContainer\'] {\n    display: flex;\n    flex-direction: row;\n\n    div[name=\'listPanelClearSelected\'] {\n      align-items: center;\n      color: ', ';\n      cursor: pointer;\n      display: flex;\n      font-size: 0.917rem;\n      height: 24px;\n      padding-left: 12px;\n      padding-right: 12px;\n    }\n  }\n\n  > div#listPanelItemContainer {\n    box-sizing: border-box;\n    max-height: 220px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    width: 100%;\n\n    > div[name=\'listPanelOption\'] {\n      width: 100%;\n      padding-left: 16px;\n      line-height: 25px;\n\n      font-family: ', ';\n      font-size: ', ';\n      color: ', ';\n\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      cursor: pointer;\n\n      &:hover {\n        background-color: ', ';\n        outline: none;\n      }\n\n      &:focus {\n        background-color: ', ';\n        outline: none;\n      }\n\n      > span {\n        margin-left: 4px;\n      }\n\n      &.listPanelOption-disabled {\n        color: ', ' !important;\n        cursor: default;\n      }\n    }\n  }\n\n  > div#searchBoxContainer {\n    min-height: 40px;\n    height: 40px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    > div#searchBox {\n      width: 100%;\n      text-align: center;\n      vertical-align: middle;\n      position: relative;\n\n      &:focus {\n        border: 1px solid #64adc2;\n        box-shadow: inset 0 0 3px 0 #336f8f;\n      }\n\n      > div {\n        height: 24px;\n        width: 24px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 11px;\n        color: #999999;\n        position: absolute;\n        left: 8px;\n      }\n\n      > input#searchTextBox {\n        font-family: ', ';\n        font-size: 11px;\n        border: 1px solid #e3e3e3;\n        border-radius: 2px;\n        background: #ffffff;\n        height: 22px;\n        min-width: calc(100% - 40px);\n        max-width: calc(100% - 40px);\n        outline: none;\n        color: #333333;\n        display: inline-block;\n        padding-top: 0px;\n        padding-right: 0px;\n        padding-bottom: 0px;\n        padding-left: 24px;\n        margin-bottom: 0px;\n        line-height: normal;\n        vertical-align: middle;\n\n        &:focus {\n          border: 1px solid #64adc2;\n          box-shadow: inset 0 0 3px 0 #336f8f;\n        }\n      }\n    }\n  }\n'], ['\n  background-color: #ffffff;\n  border-bottom: solid 1px ', ';\n  border-left: solid 1px ', ';\n  border-right: solid 1px ', ';\n  border-radius: 0 0 2px 2px; // top-left, top-right, bottom-right, bottom-left\n  border-top: none;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n  color: ', ';\n  font-family: ', ';\n  font-size: ', ';\n  max-height: 260px;\n  outline: none;\n  right: 0px;\n  top: 0px;\n  z-index: 1000;\n\n  width: ', ';\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n\n  div[name=\'listPanelGroupContainer\'] {\n    display: flex;\n    flex-direction: row;\n\n    div[name=\'listPanelClearSelected\'] {\n      align-items: center;\n      color: ', ';\n      cursor: pointer;\n      display: flex;\n      font-size: 0.917rem;\n      height: 24px;\n      padding-left: 12px;\n      padding-right: 12px;\n    }\n  }\n\n  > div#listPanelItemContainer {\n    box-sizing: border-box;\n    max-height: 220px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    width: 100%;\n\n    > div[name=\'listPanelOption\'] {\n      width: 100%;\n      padding-left: 16px;\n      line-height: 25px;\n\n      font-family: ', ';\n      font-size: ', ';\n      color: ', ';\n\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      cursor: pointer;\n\n      &:hover {\n        background-color: ', ';\n        outline: none;\n      }\n\n      &:focus {\n        background-color: ', ';\n        outline: none;\n      }\n\n      > span {\n        margin-left: 4px;\n      }\n\n      &.listPanelOption-disabled {\n        color: ', ' !important;\n        cursor: default;\n      }\n    }\n  }\n\n  > div#searchBoxContainer {\n    min-height: 40px;\n    height: 40px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    > div#searchBox {\n      width: 100%;\n      text-align: center;\n      vertical-align: middle;\n      position: relative;\n\n      &:focus {\n        border: 1px solid #64adc2;\n        box-shadow: inset 0 0 3px 0 #336f8f;\n      }\n\n      > div {\n        height: 24px;\n        width: 24px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 11px;\n        color: #999999;\n        position: absolute;\n        left: 8px;\n      }\n\n      > input#searchTextBox {\n        font-family: ', ';\n        font-size: 11px;\n        border: 1px solid #e3e3e3;\n        border-radius: 2px;\n        background: #ffffff;\n        height: 22px;\n        min-width: calc(100% - 40px);\n        max-width: calc(100% - 40px);\n        outline: none;\n        color: #333333;\n        display: inline-block;\n        padding-top: 0px;\n        padding-right: 0px;\n        padding-bottom: 0px;\n        padding-left: 24px;\n        margin-bottom: 0px;\n        line-height: normal;\n        vertical-align: middle;\n\n        &:focus {\n          border: 1px solid #64adc2;\n          box-shadow: inset 0 0 3px 0 #336f8f;\n        }\n      }\n    }\n  }\n']);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _ListPanelBase = require('./ListPanelBase');
var _ListPanelBase2 = _interopRequireDefault(_ListPanelBase);
var _XactlyColors = require('../../themes/XactlyColors');
var _XactlyColors2 = _interopRequireDefault(_XactlyColors);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ListPanel = (0, _styledComponents2['default'])(_ListPanelBase2['default'])(_templateObject, function (props) {
  return props.theme.mainBorderColor;
}, function (props) {
  return props.theme.mainBorderColor;
}, function (props) {
  return props.theme.mainBorderColor;
}, function (props) {
  return props.theme.mainFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  switch (props.size) {
    case 'xSmall':
      return props.theme.xSmallSize;
    case 'small':
      return props.theme.smallSize;
    case 'medium':
      return props.theme.mediumSize;
    case 'large':
      return props.theme.largeSize;
  }
}, function (props) {
  return props.theme.colorTextModerate;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.mainFontColor;
}, function (props) {
  return props.theme.focusBackgroundColor;
}, function (props) {
  return props.theme.focusBackgroundColor;
}, _XactlyColors2['default'].xCoalLight, function (props) {
  return props.theme.fontFamily;
});
ListPanel.defaultProps = {
  theme: {
    fontFamily: 'Verdana',
    fontSize: '12px',
    mainFontColor: '#346F8F',
    mainBorderColor: '#E3E3E3',
    mainBoxShadow: '0 0 2px 0 rgba(0,0,0,0.10)',
    // offset-x | offset-y | blur-radius | spread-radius | color
    xSmallSize: '72px',
    smallSize: '120px',
    mediumSize: '200px',
    largeSize: '472px',
    focusBackgroundColor: '#EAF0F4'
  }
};
ListPanel.propTypes = {
  /**
   * Function bound to the click event of the add new button.
   */
  addNewButtonClickHandler: _propTypes2['default'].func,
  /*
  A function which can be used to obtain the innerRef of the Dropdown Base
  */
  setRef: _propTypes2['default'].func,
  /**
   * Function bound to the change event raised by the component when a different
   * item from the list is selected.
   */
  changeHandler: _propTypes2['default'].func,
  /**
   * An array of objects bound to the list of items in the dropdown.
   * Format:
   * [
   *      { name: 'Aston Martin', value: 1 },
   *      { name: 'Ferrari', value: 2 },
   *      { name: 'Jaguar', value: 3 },
   *      { name: 'Land Rover', value: 4 }
   * ]
   * The textPropName in this case would be 'name'.
   * The valuePropName would be 'value'.
   */
  data: _propTypes2['default'].array,
  /**
   * Key name in the data array object to get the boolean value that determines if the list item is disabled or not.
   */
  disabledPropName: _propTypes2['default'].string,
  /**
   * Height of the panel. It can be in pixels or percentage.
   * The height is applied as max-height.
   */
  height: _propTypes2['default'].string,
  /**
   * The id for the component. If one is not provided a unique id is used.
   * Sets the id attribute on the element.
   */
  id: _propTypes2['default'].string,
  /**
   * This object defines the labels (text) displayed on the component buttons, help, tooltips etc.
   * The object values have the text that is displayed.
   */
  labels: _propTypes2['default'].shape({
    /**
     * The text for the 'add new' button. The text should be in the format 'Add New {{Object Name}}'.
     * If the value of this prop is set then this button is visible in the drop down list at the top
     * of the list. It cannot be selected but can be clicked. The associated 'addNewButtonClickHandler'
     * can be set to a function that is called when the button is clicked.
     */
    addNewButtonText: _propTypes2['default'].string,
    /**
     * When this key-value pair is added to the labels object, a Clear Selected button is displayed in the component.
     * When the Clear Selected button is clicked all the selected options are deselected and the change event is triggered.
     * Use this feature for multi-select drop down when the items are grouped For e.g. in the GroupedDropDown component.
     * Typical use case is for use in filters.
     */
    clearSelectedLabel: _propTypes2['default'].string,
    /**
     * When this key is set, a checkbox is added on top of the other options allowing the user to either select all or
     * deselect all options.
     */
    selectAllText: _propTypes2['default'].string,
    /**
     * When this key is set, the text of the select all checkbox is changed in response to a search made.
     */
    selectResultsText: _propTypes2['default'].string
  }),
  /**
   * Set this prop value to true if the search box should be enabled and shown.
   * Default is false.
   */
  searchBox: _propTypes2['default'].bool,
  /**
   * The selected value can be set when the component is loaded.
   */
  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].array]),
  /**
   * When a function is assigned to this prop, it will be called when either the user
   * clicks the item in the list or presses enter on the item in the list.
   * The drop down component will need to use this event to hide the list when
   * a selection is made.
   */
  selectionConfirmedHandler: _propTypes2['default'].func,
  /**
   * Key name in the data array object to get the text to display for the list item.
   */
  textPropName: _propTypes2['default'].string,
  /**
   * Key name in the data array object to get the value bound to the item in the list.
   */
  valuePropName: _propTypes2['default'].string,
  /**
   * The width of the panel. It can be in pixels or percentage.
   */
  width: _propTypes2['default'].string
};
exports['default'] = ListPanel;